export const spaceXS = "4px";
export const spaceS = "8px";
export const spaceM = "16px";
export const spaceL = "24px";
export const spaceXL = "32px";
export const spaceXXL = "40px";
export const fontSize80 = "66px";
export const fontSize70 = "62px";
export const fontSize60 = "42px";
export const fontSize50 = "26px";
export const fontSize40 = "22px";
export const fontSize30 = "16px";
export const fontSize20 = "14px";
export const fontSize10 = "12px";
export const fontSize65 = "52px";
export const fontSize55 = "34px";
export const fontSize35 = "18px";
export const defaultFontSize = "16px";
export const contrastColor100 = "#1d1d1d";
export const contrastColor90 = "#464648";
export const contrastColor70 = "#6f6f71";
export const contrastColor40 = "#c2c7cc";
export const contrastColor30 = "#e7eaec";
export const contrastColor20 = "#f4f5f6";
export const contrastColor10 = "#ffffff";
export const brandColor110 = "#00616f";
export const brandColor100 = "#01757b";
export const brandColor90 = "#01838a";
export const brandColor80 = "#00a3ad";
export const brandColor70 = "#00b6ad";
export const brandColor20 = "#eef8f9";
export const brandHover = "#01757b";
export const promoColor90 = "#582c83";
export const promoColor20 = "#d6b8f3";
export const decorativeA90 = "#ff5252";
export const decorativeB90 = "#ff4081";
export const decorativeC90 = "#19a486";
export const decorativeD90 = "#3087fa";
export const decorativeE90 = "#a467d3";
export const alertColor100 = "#870202";
export const alertColor90 = "#f39200";
export const alertColor20 = "#fbaeae";
export const successColor100 = "#006b04";
export const successColor90 = "#08890d";
export const successColor70 = "#78be20";
export const successColor20 = "#c4e995";
export const errorColor110 = "#870202";
export const errorColor100 = "#a30e0e";
export const errorColor90 = "#be2020";
export const errorColor20 = "#fbaeae";
export const errorHover = "#870202";
export const lineHeight = "1.5rem";
export const lineHeightSmall = "1.25rem";
export const screenWidthXS = "480px";
export const screenWidthS = "768px";
export const screenWidthM = "1024px";
export const screenWidthL = "1200px";
export const primaryA900 = "#0a121a";
export const primaryA700 = "#3f464c";
export const primaryA600 = "#5d6268";
export const primaryA500 = "#7b7f84";
export const primaryA300 = "#b7b9bb";
export const primaryA100 = "#e7e7e8";
export const primaryA50 = "#f9f9f9";
export const primaryA0 = "#ffffff";
export const primaryB400 = "#c7b49e";
export const primaryB300 = "#e1ceb6";
export const primaryB200 = "#f7e4cb";
export const primaryB100 = "#fbf1e4";
export const primaryB50 = "#fdf8f2";
export const secondaryA700 = "#334239";
export const secondaryA600 = "#405348";
export const secondaryA500 = "#4e6659";
export const secondaryA50 = "#eff4f1";
export const accentA700 = "#1f589d";
export const accentA600 = "#276bbe";
export const accentA500 = "#368cf5";
export const accentA100 = "#c6dffe";
export const accentA50 = "#eff6fe";
export const statusWarningBase = "#f39200";
export const statusWarning100 = "#fce8c9";
export const statusSuccess100 = "#ecf5ee";
export const statusSuccess600 = "#06760a";
export const statusError100 = "#f8e7e7";
export const statusError200 = "#f1cfcf";
export const statusError700 = "#931818";
export const statusError800 = "#761414";
export const statusErrorBase = "#be2020";
export const statusSuccessBase = "#08890d";
export const spot = "#ff5e6f";
export const decorativeA = "#6e8ecc";
export const decorativeB = "#38a183";
export const decorativeC = "#d4527d";
export const decorativeD = "#bd852e";
export const zIndexHeader = "1000";
export const zIndexSideModal = "1100";
export const zIndexDialog = "1200";
export const zIndexDropdown = "1300";
export const zIndexTooltip = "1400";
export const toastShadow = "0px 8px 16px rgba(0, 0, 0, 0.24)";
export const dropdownShadow = "0px 3px 10px rgba(29, 29, 29, 0.37)";
export const animationFast = "200ms";
export const headerHeight = "48px";